import React from 'react'
import { makeStyles } from '@material-ui/styles'
import CopilotInsightCard from '../common/BaseCopilotInsightWidget'
import { Grid } from '@material-ui/core'
import RecentScansOverview from './RecentScansOverview'
import OralHygiene from './OralHygiene'
import ScanInsightsEmptyState from './ScanInsightsEmptyState'
import useTimelineItemSelection from 'components/Patients/Timeline/V2/useTimelineItemSelection'
import LatestScanTaggings from './LatestScanTaggings'
import ScanInsightsHeader from './ScanInsightsHeader'

const useStyles = makeStyles(theme => ({
  scanInsightsRootWidgetRoot: {
    height: '100%'
  }
}))

const ScanInsightsWidget = ({ isLoading, latestScanTimelineItems = [] }) => {
  const classes = useStyles()

  const { setSelectedTimelineItem } = useTimelineItemSelection()
  const shouldDisplayEmptyState = !isLoading && latestScanTimelineItems.length === 0

  return (
    <CopilotInsightCard className={classes.scanInsightsRootWidgetRoot}>
      <Grid container direction="column" wrap="nowrap" style={{ height: '100%', maxWidth: 350 }}>
        <Grid item style={{ marginBottom: 8 }}>
          <ScanInsightsHeader />
        </Grid>
        {shouldDisplayEmptyState ? (
          <Grid item style={{ height: '100%' }}>
            <ScanInsightsEmptyState />
          </Grid>
        ) : (
          <>
            <Grid item style={{ marginBottom: 12 }}>
              <Grid container direction="column" wrap="nowrap" style={{ height: '100%' }} spacing={2}>
                <Grid item>
                  <Grid container direction="row" alignItems="center">
                    <Grid item xs={6}>
                      <RecentScansOverview
                        isLoading={isLoading}
                        latestScanTimelineItems={latestScanTimelineItems}
                        setSelectedTimelineItem={setSelectedTimelineItem}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <OralHygiene latestScanTimelineItems={latestScanTimelineItems} isLoading={isLoading} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <LatestScanTaggings latestScanTimelineItems={latestScanTimelineItems} isLoading={isLoading} />
            </Grid>
          </>
        )}
      </Grid>
    </CopilotInsightCard>
  )
}

export default ScanInsightsWidget
